import { render, staticRenderFns } from "./header_default.vue?vue&type=template&id=024fc770&"
import script from "./header_default.vue?vue&type=script&lang=js&"
export * from "./header_default.vue?vue&type=script&lang=js&"
import style0 from "./header_default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports